const enum DataActions {
    ERRORTEST = 'ERRORTEST',
    SET_DEALERS = 'SET_DEALERS',
    SET_BUSINESS_UNITS = 'SET_BUSINESS_UNITS',
}

interface Payload {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any
}

export interface DataAction {
    type: DataActions
    payload?: Payload
}

export default DataActions
